import{RP_GAS_PERFORMANCE_MODEL_LIST, RP_GAS_PERFORMANCE_PAGINATION, RP_GAS_PERFORMANCE_SEARCH,RP_GAS_PERFORMANCE_DROP_DOWN_SEARCH_YEAR}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: RP_GAS_PERFORMANCE_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: RP_GAS_PERFORMANCE_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: RP_GAS_PERFORMANCE_PAGINATION,
    payload
})

export const setDropDownSearchYear = (payload) => ({
    type: RP_GAS_PERFORMANCE_DROP_DOWN_SEARCH_YEAR,
    payload
})